
<div *ngIf="loadFinished && usersService.hasGlobalSectionRight('Admin')"
    style="position:relative;left:30px;width: 95%;">
    <div class="row vertical-separator" style="height: 10px;"></div>
    <div class="row" style="height:60px">
        <div class="col-md-2">
            <div style="display:flex; height:100%; align-items:center">
                <h3 >Portal running processes</h3>
            </div>
        </div>
        <div class="col-md-10" style="display: flex;">
            <div class="card mb-3 widget-content bg-premium-dark" *ngFor="let manualProcessInfo of manualProcessesInfo"  style="margin-right: 10px;">
                <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left" style="width: 100% !important">
                        <div class="widget-heading">{{manualProcessInfo.name}}</div>
                    </div>
                    <div class="widget-content-right" style="margin-left:10px; text-align: center;">
                        <div class="widget-numbers text-warning">
                            <span>{{manualProcessInfo.runningProcesses | number:'':'es'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row vertical-separator"></div>
    <div class="row" *ngIf="audiencesDataSource.data.length > 0 || transfersDataSource.data.length > 0">
        <div class="col-md-12">
            <mat-tab-group>
                <mat-tab label="Audiences running or failed" *ngIf="audiencesDataSource.data.length > 0">
                    <eris-table [dataSource]="audiencesDataSource" #parent>
                        <ng-container *ngFor="let audience of parent.data; index as i">
                            <tr>
                                <th scope="row" class="align-middle" style="width: 5%;">{{ audience.id }}</th>
                                <td class="align-middle" style="width: 10%">
                                    <img width="48" [src]="companiesService.getCompanyLogoSrc(audience.company.id)" />
                                </td>
                                <td class="align-middle" style="width: 45%; word-break: break-all;">{{ audience.name }}</td>
                                <td class="align-middle" style="width: 7%;">{{ audience.created | date }}</td>
                                <td class="align-middle" style="width: 7%;">{{ audience.updated | date }}</td>
                                <td class="align-middle" style="width: 7%;">{{ audience.profilesCount | number:'':'es' }}
                                </td>
                                <td class="align-middle" style="width: 4%;">
                                    <div>
                                        <div class="font-icon-wrapper-button" (click)="showAudienceDetails(audience)"
                                            style="cursor:pointer;display:inline-flex;width:44px;height:44px; ">
                                            <i class="pe-7s-info"></i>
                                            <i class="pe-7s-ticket"
                                                style="font-size:1.2em;position:relative;left:-10px;top:20px"
                                                *ngIf="!!audience.tags && audience.tags.length > 0"></i>
                                        </div>
                                    </div>
                                </td>
                                <td class="align-middle" style="width: 10%;">
                                    <div>
                                        <div class="font-icon-wrapper">
                                            <i [class]="getStatusStyle(audience)"></i>
                                        </div>
                                        <div class="d-flex justify-content-center" style="text-align:center">
                                            {{ getStatusLabel(audience) }}
                                        </div>
                                    </div>
                                </td>
                                <td class="align-middle" style="width: 5%;">
                                    <div>
                                        <button mat-icon-button [matMenuTriggerFor]="menu"
                                            aria-label="Example icon-button with a menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item (click)="refreshAudience(audience)">
                                                <mat-icon class="pe-7s-refresh-2"></mat-icon>
                                                <span>Refresh</span>
                                            </button>
                                            <mat-divider></mat-divider>
                                            <button mat-menu-item (click)="deleteAudience(audience)">
                                                <mat-icon class="pe-7s-trash"></mat-icon>
                                                <span>Delete audience</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </eris-table>
                </mat-tab>
                <mat-tab label="Transfers running, failed or with files running or failed" *ngIf="transfersDataSource.data.length > 0">
                    <eris-table [dataSource]="transfersDataSource" #parent>
                        <ng-container *ngFor="let transfer of parent.data; index as i">
                            <tr>
                                <td class="align-middle" style="width: 5%">
                                    <img width="48" [src]="companiesService.getCompanyLogoSrc(transfer.audience.company.id)" />
                                </td>                              
                                <td scope="row" class="align-middle text-center" style="width: 8%;"><img width="48px" height="48px"
                                        [src]="transfersService.getTargetPlatformIcon(transfer)" />
                                </td>
                                <th scope="row" class="align-middle" style="width: 4%;">{{ transfer.id }}</th>
                                <td scope="row" class="align-middle" style="width: 15%; word-break: break-all;">{{ transfer.name }}</td>
                                <td scope="row" class="align-middle" style="width: 20%; word-break: break-all;">{{ transfer.audience.id
                                    }} - {{ transfer.audience.name }}</td>
                                <td scope="row" class="align-middle" style="width: 8%;">{{ transfer.created | date }}</td>
                                <td scope="row" class="align-middle" style="width: 7%;">
                                    {{ transfer.scheduling.description }}
                                    <span *ngIf="!!transfer.schedulingEndDate">until {{ transfer.schedulingEndDate | date }}</span>
                                    <span *ngIf="!transfer.schedulingEndDate &&  transfer.schedulingId != 1">indefinitely</span>
                                </td>
                                <td scope="row" class="align-middle" style="width: 25%; word-break: break-all;">
                                    <ng-container *ngFor="let attribute of transfer.customAttributes">
                                        {{ transfersService.getTransferAttributeDescription(attribute.attributeId,
                                        transfer.targetPlatform) }} : {{ attribute.value }}<br />
                                    </ng-container>
                                </td>
                                <td scope="row" class="align-middle text-center" style="width: 6%; word-break: break-all;">
                                    <ng-container *ngFor="let idGraphType of transfer.identifiersTypes">
                                        <img [src]="audiencesService.getIdentifiersTypeSmallIcon(idGraphType)"
                                            [title]="audiencesService.getIdGraphTypeDescription(idGraphType)" alt="icon"
                                            style="width: 24px; height: 24px; margin: 3px;">
                                    </ng-container>
                                </td>
                                <td scope="row" class="align-middle text-center" style="width: 5%;">
                                    <!--
                                    <div *ngIf="transfer?.files?.length > 0" (click)="toggleTransferFilesVisibility(transfer)"
                                        class="btn-success badge badge-pill badge-success"
                                        style="padding: 0.4rem 0.6rem; margin-left: 0.5rem;">
                                        {{transfer?.files?.length}} files
                                        <i class="fa fa-angle-up" aria-hidden="true"
                                            style="margin:3px; font-size: 1rem;vertical-align: middle;"
                                            *ngIf="filesVisibleTransferId == transfer.id"> </i>
                                        <i class="fa fa-angle-down" aria-hidden="true"
                                            style="margin:3px;font-size: 1rem;vertical-align: middle;"
                                            *ngIf="filesVisibleTransferId != transfer.id"> </i>
                                    </div>
                                    -->
                                </td>
                                <td scope="row" class="align-middle" style="width: 2%;">
                                    <div *ngIf="audience?.status != 10">
                                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
                                            (menuOpened)="onMenuOpenedInternal()">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu" (closed)="onMenuClosedInternal($event)">
                                            <button mat-menu-item [disabled]="transfer.audience?.status != 2"
                                                (click)="createAndSendFile(transfer)">
                                                <mat-icon class="pe-7s-next-2"></mat-icon>
                                                <span>Send new file</span>
                                            </button>
                                            <!--
                                            <button mat-menu-item [disabled]="transfer.audience?.status != 2"
                                                (click)="createFile(transfer)">
                                                <mat-icon class="pe-7s-note2"></mat-icon>
                                                <span>Create file (no send)</span>
                                            </button>
                                            <button mat-menu-item [disabled]="transfer.audience?.status != 2"
                                                (click)="updateTransfer(transfer)">
                                                <mat-icon class="pe-7s-note2"></mat-icon>
                                                <span>Update transfer</span>
                                            </button>
                                            -->
                                        </mat-menu>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="transfer?.files?.length > 0">
                                <th scope="row" colspan="1"></th>
                                <td colspan="10">
                                    <table class="table table-striped">
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col">ID</th>
                                            <th scope="col">Creation date</th>
                                            <th scope="col">Size</th>
                                            <th scope="col">Times sent</th>
                                            <th scope="col">Last sent date</th>
                                            <th scope="col">Status</th>
                                            <th scope="col"></th>
                                        </tr>
                                        <tr *ngFor="let file of transfer.files; index as j">
                                            <th class="align-middle" style="width: 5%;">
                                                <div class="font-icon-wrapper">
                                                    <i class="fa fa-file-text" aria-hidden="true" style="font-size: 1.5rem;"> </i>                                    
                                                </div>                                                
                                            </th>
                                            <th class="align-middle" style="width: 10%;">{{ file.id }}</th>
                                            <td class="align-middle" style="width: 10%;">{{ file.created | date }}
                                            </td>
                                            <td class="align-middle" style="width: 7%;">{{ file.bytesSize | bytes }}
                                            </td>
                                            <td class="align-middle" style="width: 3%;">{{ file.timesSent.length }}
                                            </td>
                                            <td class="align-middle" style="width: 10%;">{{ file.timesSent.length >
                                                0 ? (file.timesSent[file.timesSent.length - 1].timeSent |
                                                date:'medium') : '' }}</td>
                                            <td class="align-middle" style="width: 5%;">
                                                <div>
                                                    <div class="font-icon-wrapper">
                                                        <i [class]="getFileStatusStyle(file)"></i>
                                                    </div>
                                                    <div class="d-flex justify-content-center">
                                                        {{ getFileStatusLabel(file) }}
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="align-middle" style="width: 10%;">
                                                <div class="btn" style="padding: 0.1rem 0.1rem"
                                                    title="Delete transfer file">
                                                    <div class="font-icon-wrapper-medium"
                                                        (click)="deleteTransferFile(transfer, file)">
                                                        <i class="pe-7s-trash"></i>
                                                    </div>
                                                </div>
                                                <div class="btn" style="padding: 0.1rem 0.1rem"
                                                    title="Resend transfer file">
                                                    <div class="font-icon-wrapper-medium"
                                                        (click)="resendTransferFile(transfer, file)">
                                                        <i class="pe-7s-next-2"></i>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </ng-container>
                    </eris-table>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>